export default {
  SET_USUARIOS(state, payload) {
    state.usuarios = payload;
  },
  SET_FILTROS(state, payload) {
    state.filtros = payload;
  },
  SET_USERDATA(state, payload) {
    state.userData = payload;
  },
  SET_USUARIO_TERMS_CONDITIONS(state, payload) {
    state.termsConditions = payload;
  },
};
